import { memo } from 'react';
import { Filter as FilterType } from '../../types';
import { Filter } from './components';

type FiltersSidebarProps = {
  filters: FilterType[];
};

export const FiltersSidebarComponent = ({ filters }: FiltersSidebarProps) => {
  return (
    <ul className="list-none px-2 py-0 m-0 min-w-[300px] w-[300px] max-h-screen sticky top-0 overflow-y-auto">
      {filters.map((filter, index) => (
        <Filter key={filter.title} filter={filter} isFirst={index === 0} />
      ))}
    </ul>
  );
};

export const FiltersSidebar = memo(FiltersSidebarComponent, (prevProps, nextProps) => {
  return prevProps.filters === nextProps.filters;
});
